<div class="info-popup-container" (mouseenter)="showPopup()" (mouseleave)="hidePopup()">
    <span class="info-content"><ng-content></ng-content></span>
    <span class="info-icon">?</span>
    <div class="popup" *ngIf="true">
        <ng-content select="[popupData]"></ng-content>
    </div>
</div>
  